import { render, staticRenderFns } from "./UpgradeServicesDoc.vue?vue&type=template&id=55dc930b"
import script from "./UpgradeServicesDoc.vue?vue&type=script&lang=js"
export * from "./UpgradeServicesDoc.vue?vue&type=script&lang=js"
import style0 from "./UpgradeServicesDoc.vue?vue&type=style&index=0&id=55dc930b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports